import { Amplify } from 'aws-amplify';
import config from '../aws-exports';

import "@aws-amplify/ui-react/styles.css";
import {
  withAuthenticator,
//   Button,
//   Heading,
//   Image,
//   View,
//   Card,
} from "@aws-amplify/ui-react";
import Orders from './Orders';


Amplify.configure(config);





function Dashboard({ signOut }) {
  return (
    <>
    <div className='dashboard-menu'>
        <Orders/>
    </div>
    </>
  );
}

export default withAuthenticator(Dashboard);